export const eventRessource = () => {
    const ressourceList = document.querySelector('.template-ressources-list');
    if (ressourceList) {
        const buttons = ressourceList.querySelectorAll('.card__btn') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const card = button.closest('.card');
                const title = card?.querySelector('.card__title')?.textContent?.trim() || 'na';
                const type = button.classList.contains('card__url') ? 'url' : 'document';

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'ressource',
                    'typeRessource': type,
                    'nomDocument': title
                });
            });
        });
    }
}
